export default "__VITE_ASSET__D0G9iLjU__"